module.exports = __webpack_public_path__ + "img/logoNavbar.4104349c.png";